import { requestStatus } from "../../../../../constants";
import { useUser } from "../../../../../hook";

export const useStep = () => {
  const { checkCurrentUser } = useUser();

  const getCurrentInfoStep = (stepsList: any[], request: any) => {
    let stepNum;
    let step;
    let userStepNum;
    let userStep;
    let currentStatus: "error" | "finish" | "wait" | "process" | undefined =
      "finish";
    for (let i = 1; i <= stepsList.length - 1; i++) {
      const statusField = stepsList[i].statusField;
      if (!request[statusField] && !stepNum && stepNum !== 0) {
        stepNum = i - 1;
        step = stepsList[i - 1];
      }
      if (checkCurrentUser(stepsList[i].email)) {
        userStepNum = i;
        userStep = stepsList[i];
      }
    }

    if (stepNum === 0) {
      currentStatus = "finish";
    } else {
      const approvedStatus = request[stepsList[stepNum as number].statusField];
      if (approvedStatus === requestStatus.approved) {
        currentStatus = "finish";
      }
      if (approvedStatus === requestStatus.rejected) {
        currentStatus = "error";
      }
    }

    const isShowConfirmButton =
      userStepNum &&
      userStepNum - 1 === stepNum &&
      request[step.statusField] !== requestStatus.rejected;

    return {
      stepNum,
      step,
      currentStatus,
      userStepNum,
      userStep,
      isShowConfirmButton,
    };
  };

  const checkRequestStatus = (steps: any[], request: any) => {
    const mappedSteps = steps.map((step) => {
      if(!request[step.titleField]) return null;
      return {
        email: request[step.titleField].split("|")[0],
        requestStatus: request[step.statusField],
      };
    });

    const result = mappedSteps.find((e) => checkCurrentUser(e?.email));

    if (result?.requestStatus) return requestStatus.approved;
    return null;
  };

  return { getCurrentInfoStep, checkRequestStatus };
};
